import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Layouts
import PublicLayout from "./layouts/PublicLayout";
import AdminLayout from "./layouts/AdminLayout";

// Public Pages
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";

// Admin Pages
import PrivateRoute from "./components/admin/PrivateRoute.jsx";
import AuthPage from "./pages/admin/LoginPage.jsx";
import Dashboard from "./pages/admin/Dashboard.jsx";
import SelectedCar from "./pages/SelectedCar";
// Booking Page
import BookACar from "./pages/BookACar";
import BookACarThree from "./pages/BookACarThree";
import BookACarFour from "./pages/BookACarFour"; 
import ConfirmBooking from "./pages/ConfirmBooking";
import About from "./pages/about";
import OurCar from "./pages/OurCar";
import OurCars from "./pages/OurCars";
import CarDetails from "./pages/CarDetails";
import ModifyReservation from "./pages/ModifyReservation.jsx";
import FAQ from "./pages/FAQ.jsx";
import TermsAndConditions from "./pages/TermsAndConditions.jsx";
import Policy from "./pages/Policy.jsx";
import Sitemap from "./pages/Sitemap.jsx";
import Offer from "./pages/Offer.jsx";
import Booking from "./pages/Booking.jsx";
import SendRequestCar from "./pages/SendRequestCar.jsx";
import RequestSent from "./pages/RequestSent.jsx";
function App() {
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/admin";
  };

  return (
    <BrowserRouter>

      <Toaster
        position="top-right"
        reverseOrder={false}
      />

      <Routes>

        {/* =========================
            PUBLIC WEBSITE ROUTES
        ========================== */}

        <Route element={<PublicLayout />}>

          {/* Home */}
          <Route
            path="/"
            element={<HomePage />}
          />
<Route
  path="/about"
  element={<About />}
/>
          {/* Contact */}
          <Route
            path="/contact"
            element={<ContactPage />}
          />

          {/* Book A Car */}
          <Route
            path="/bookacar"
            element={<BookACar />}
          />
<Route
    path="/bookacarthree"
    element={<BookACarThree />}
  />

  <Route
  path="/bookacarfour"
  element={<BookACarFour />}
/>
       
<Route
  path="/confirmbooking"
  element={<ConfirmBooking />}
/>
 <Route
    path="/cars"
    element={<OurCar />}
  />
  <Route
  path="/ourcars"
  element={<OurCars />}
/>
  <Route
  path="/cardetails"
  element={<CarDetails />}
/>
 <Route
    path="/modify-reservation"
    element={<ModifyReservation />}
  />
   <Route
    path="/modify-reservation"
    element={<ModifyReservation />}
  />
   <Route
    path="/faq"
    element={<FAQ />}
  />
 <Route
    path="/terms-and-conditions"
    element={<TermsAndConditions />}
  />
   <Route
    path="/policy"
    element={<Policy />}
  />
   <Route
    path="/sitemap"
    element={<Sitemap />}
  />
 <Route
    path="/special-offer"
    element={<Offer />}
  />
   <Route
    path="/booking"
    element={<Booking />}
  />

  <Route path="/sendrequest" element={<SendRequestCar />} />
    <Route path="/requestsent" element={<RequestSent />} />
 </Route>


        {/* =========================
            ADMIN LOGIN
        ========================== */}

        <Route
          path="/admin"
          element={<AuthPage />}
        />
<Route
  path="/selected-car"
  element={<SelectedCar />}
/>

        {/* =========================
            PROTECTED ADMIN ROUTES
        ========================== */}

        <Route
          element={
            <PrivateRoute>
              <AdminLayout handleLogout={handleLogout} />
            </PrivateRoute>
          }
        >

          <Route
            path="/admin/dashboard"
            element={<Dashboard />}
          />

        </Route>

      </Routes>

    </BrowserRouter>
  );
}

export default App;